import { Injectable } from '@angular/core';
import * as uuid from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class UtilDocumentIdService {

  constructor() { }

  uuidLength = 36;

  generateId() {
    // use a v1 id. This includes the device hardware in the generation, so there is more chance of uniqueness
    return uuid.v1();
  }

  isValid(id) {
    // start with an initial test of checking that the length is correct
    return id && id.length === this.uuidLength;
  }

}
